<template>
    <div>
        <div v-if="isEnabled">
            <div class="content" :style="{ height: Number.isInteger(height) ? height + 'px' : height }">
                <slot></slot>
            </div>
            <a v-if="!isReadingMore" href="javascript:" @click="readMore">read more</a>
            <a v-else href="javascript:" @click="readLess">read less</a>
        </div>
        <slot v-else></slot>
    </div>
</template>

<script>
/*
* Code component
* ---
* Example usage:
*
* <read-more class="rte" :less-height="42">
*     {{ product.description }}
* </read-more>
*/

export default {
    props: {
        lessHeight: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            isEnabled: false,
            isReadingMore: false,
            originalHeight: 'auto',
            height: 0
        }
    },

    mounted() {
        // need to use offsetHeight to get a rough idea of if the content is bigger 
        // than the collapsed height to trigger the enable state on the component
        if (this.$el.offsetHeight > this.lessHeight) {
            this.readLess();
            this.isEnabled = true;
        }
    },

    methods: {
        readMore() {
            this.isReadingMore = true;
            this.height = this.originalHeight;
        },

        readLess() {
            this.isReadingMore = false;
            this.height = this.lessHeight;
        }
    }
}
</script>

<style scoped>
.content {
    margin-bottom: 5px;
    overflow: hidden;
    transition: height .3s ease-in-out;
}

a {
    text-decoration: underline;
}
</style>